export default __webpack_public_path__ + "static/img/vogue_scene_animated_0147.d4ac76a.jpg";